import React from "react";
import Header from "./components/Header";
import About from "./components/About";
import Elements from "./components/Elements"
import Behind from "./components/Behind";
// import Pinkemon from "./components/Pinkemon"
import Features from "./components/Features";
import Nft from "./components/Nft";
import EconmicLoop from "./components/econmicLoop";
// import HomeMap from "./components/HomeMap"
import OurTeam from "./components/OurTeam";
import Token from "./components/token";
import Roadmap from "./components/Roadmap_";
import Metaverse from "./components/Metaverse";
import Footer from "../../components/layouts/Footer";
// import Partner from "./components/Partner";

export default function HomePage()
{
  return (


    <div className="main-wrapper overflow-hidden">
      <Header />
      <About />
      {/* <Elements /> */}
      {/* <Culture /> */}
      {/* <Pinkemon />
        */}
      <Nft />
      {/* <EconmicLoop /> */}
      <Features />
      <Metaverse />
      <Token />
      <Roadmap />
      <Behind />
      {/* <Footer /> */}
    </div>

  );
}
